<template>
  <div>
    <b-card>
      <b-card-body>
        <validation-observer ref="AddServiceTemplate" #default="{ invalid }">
          <b-form @submit.prevent="formValidation" @change="formChanged()">
            <b-row>
              <b-col>
                <h3 class="mb-2">Template Details</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="Template Name*" label-for="mc-Template-name">
                  <validation-provider rules="required|alphanumeric_spaces|min:3|max:100" #default="{ errors }"
                    :customMessages="{ min: 'The Template Name must be at least 3 character(s).' }" name="Template Name"
                    vid="Template Name">
                    <b-form-input id="mc-Template-name" type="text" placeholder="Enter your template name"
                      v-model="ServiceTemplateObject.orderName" :state="errors.length > 0 ? false : null" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Description" label-for="mc-Template-Description">
                  <validation-provider rules="min:3|max:250" :customMessages="{ min: 'The Description must be at least 3 character(s).' }"
                  #default="{ errors }"  name="Description" vid="Description">
                    <b-form-input id="mc-Template-Description" placeholder="Enter your description"
                      v-model="ServiceTemplateObject.orderDescription" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Selling Price" label-for="mc-Budget">
                  <validation-provider rules="numeric_decimal|min_value:0|required" #default="{ errors }" name="SellingPrice" vid="SellingPrice">
                    <b-form-input id="mc-Budget" step="0.01" placeholder="Enter your budget" type="number"
                      v-model="ServiceTemplateObject.budget" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Estimated Duration (In Hours)" label-for="mc-Estimated-Duration">
                  <validation-provider rules="numeric_decimal|min_value:0" #default="{ errors }" name="Estimated Duration"
                    vid="Estimated Duration">
                    <b-form-input id="mc-Estimated-Duration" placeholder="Enter your estimated duration" type="number"
                      v-model="ServiceTemplateObject.estimatedDuration" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group label="Staff*" label-for="mc-staff">
                  <validation-provider rules="required" #default="{ errors }" name="Staff" vid="Staff">
                    <v-select taggable multiple push-tags placeholder="Add staff" label="name"
                      v-model="selectedStaffIds" :options="staffpopulate" />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <b-col md="12" class="d-flex justify-content-between">
              <b-button type="submit" variant="primary" :disabled="loading"><b-spinner small v-if="loading"
                  class="mx-2" />Submit</b-button>
            </b-col> -->
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>

    <validation-observer ref="addProduct">
      <!-- modal Add Item-->
      <b-modal id="modal-addProduct" :hide-footer="true" ref="addProductModal" centered title="Add Product">
        <b-form @submit.prevent="handleProdSubmit">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="name">Name:</label>
                <validation-provider rules="required" #default="{ errors }" name="name">
                  <b-form-input id="name" type="text" placeholder="Name" v-model="prodName" required />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label for="qty">Quantity:</label>
                <validation-provider rules="required|numeric|min_value:0" #default="{ errors }" name="qty">
                  <b-form-input id="qty" type="number" placeholder="Quantity" v-model="prodQty" required />
                  <small v-if="errors.length" class="text-danger text-end">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="justify-content-end">
            <!--    <b-col cols="3">
         Button Add Item 
       <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
          Close
        </b-button> 
      </b-col> -->
            <b-col cols="auto">
              <!-- Button Add Item -->
              <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="addProduct">
                Save
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>
    </validation-observer>
    <!-- Items Section -->
    <b-card v-if="HasPermission(PermissionList.Inventory_Create)">
      <b-row>
        <b-col>
          <h3 class="mb-2">Item Details</h3>
        </b-col>
      </b-row>
      <div ref="itemForm" class="repeater-form" :style="{ height: itemFormHeight }">
        <b-row v-if="invoiceData.items.length > 0" v-for="(item, index) in this.invoiceData.items" :key="index"
          ref="row" class="align-items-center border rounded m-0 mb-2 p-2">
          <!-- Item Dropdown -->
          <b-col cols="12" sm="6" md="6" class="">
  <div class="flex-grow-1 d-flex flex-column">
    <b-form-group>
      <span class="d-none d-lg-inline mr-2">Items</span>
      
      <div v-if="optionsProduct.length === 0 || newProd" 
           class="d-flex justify-content-center align-items-center">
        <b-spinner variant="primary"></b-spinner>
      </div>

      <div v-else class="flex-grow-1">
        <validation-provider rules="required" v-slot="{ errors }" name="Item" :vid="`Item${index}`">
          <div class="align-items-center border rounded m-0 mb-2 p-2">
            <!-- <v-select v-model="item.id" 
                      :options="optionsProduct" 
                      label="itemTitle"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                      :clearable="false" 
                      :searchable="true"
                      class="flex-grow-1 item-selector-title"
                      style="min-width: 100%;" 
                      :append-to-body="true"
                      :max-height="400"
                      placeholder="Select Item"
                      @input="(val) => updateItemForm(index, val)" /> -->
                      <b-col cols="12" sm="6" md="6">
                      <v-select
              v-model="item.id"
              :options="optionsProduct"
              label="itemTitle"
              placeholder="Select Item"
              append-to-body
              menu-props="{ auto: true, offsetY: true, maxHeight: '200px' }"
              attach="body"
              @input="(val) => updateItemForm(index, val)"
            />
            </b-col>
            
            <small v-if="errors.length" class="text-danger mt-1">
              {{ errors[0] }}
            </small>
          </div>
        </validation-provider>
      </div>
    </b-form-group>
  </div>
</b-col>


          <!-- Quantity Input -->
          <b-col cols="12" sm="4" md="4" class="d-flex align-items-center qty-input">
            <div class="flex-grow-1">
              <b-form-group>
                <span class="d-inline d-lg-inline mr-2">Quantity*</span>
                <validation-provider rules="required|numeric|min_value:1" v-slot="{ errors }" name="Quantity"
                  :vid="`Quantity_${index}`">
                  <div class="flex-grow-1">
                    <b-form-input step="1" min-value="1" @keypress="onlyDigits" @input="autoCorrectQty" v-model="item.qty" type="number" />
                    <small v-if="errors.length" class="text-danger">{{
                      errors[0]
                    }}</small>
                  </div>
                </validation-provider>
              </b-form-group>
            </div>
          </b-col>

          <b-col cols="12" sm="2" md="1" class="d-flex justify-content-center align-items-center">
            <b-button size="sm" variant="outline-danger" class="d-flex align-items-center px-2"
              @click="removeItem(index, 'item')">
              <span class="mr-1">&times;</span> Delete
            </b-button>
          </b-col>


          <!-- Add Item Button -->
          <!-- <b-col cols="12" sm="2" md="1" class="d-flex justify-content-center align-items-center">
            <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-b-modal.modal-addProduct variant="primary" size="md">
              +
            </b-button>
          </b-col> -->
        </b-row>
      </div>
      <b-row class="align-items-center">
        <b-col md="2">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="primary" class="mt-2 mr-2"
            @click="addNewItemInItemForm">
            Add Item
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-card-body>
        <b-row>
          <b-col>
            <h3 class="mb-2">Tasks Details*</h3>
          </b-col>
        </b-row>
        <div>
          <div>
            <validation-observer ref="AddServiceTemplateDetails">
              <b-form ref="taskForm" :style="{ height: taskFormHeight }" class="repeater-form">
                <b-row v-if="items.length > 0" v-for="(item, index) in items" :id="item.id" :key="item.id"  class="mb-2">
                  <!-- Tasks -->
                  <b-col md="4">
                    <b-form-group label="Tasks*" label-for="item-tasks">
                      <validation-provider rules="required|min:3|max:250"
                        :customMessages="{ min: 'task must be at least 3 character(s).' }"
                        v-slot="{ errors, validate }" ref="taskProvider" :vid="'task_' + index" name="Tasks" class="mb-4">
                        <b-form-input :id="`item-tasks_${index}`" type="text" placeholder="Enter your tasks"
                          v-model="item.tasks" @blur="validate"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Resources -->
                  <b-col md="2">
                    <b-form-group label="Resources*" label-for="resources">
                      <validation-provider rules="required|min:0|max:250" v-slot="{ errors, validate }" ref="resourcesProvider"
                        :vid="'resources_' + index" name="Resources">
                        <b-form-input :id="`resources_${index}`" type="text" placeholder="Enter your resources"
                          v-model="item.resources" @blur="validate" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Tools -->
                  <b-col md="2">
                    <b-form-group label="Tools*" label-for="tools">
                      <validation-provider rules="required|min:0|max:250" v-slot="{ errors, validate }" ref="toolsProvider"
                        :vid="'tools_' + index" name="Tools">
                        <b-form-input :id="`tools_${index}`" type="text" placeholder="Enter your tools"
                          v-model="item.tools" @blur="validate" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Cost -->
                  <b-col lg="2" md="1">
                    <b-form-group label="Cost*" label-for="price">
                      <validation-provider rules="required|numeric_decimal|min_value:0.01" v-slot="{ errors, validate }" ref="priceProvider"
                        :vid="'price_' + index" name="Price">
                        <b-form-input :id="`price_${index}`" type="number" placeholder="Enter your price"
                          v-model="item.price" @blur="validate" />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- Remove Button -->
                  <b-col lg="2" md="3" class="mb-50">
                    <b-button variant="outline-danger" class="mt-0 mt-md-2" @click="removeItem(index, 'task')">
                      <feather-icon icon="XIcon" class="mr-25" />
                      <span>Delete</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12" v-if="items.length > 1">
                    <hr />
                  </b-col>

                </b-row>
              </b-form>
            </validation-observer>
          </div>
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="AddNew" class="mt-1">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add New</span>
          </b-button>
          <b-row>
            <b-col cols="12" style="text-align: right">
              <b-button variant="outline-primary" class="btn btn-primary" @click="formValidation()">Create</b-button>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>

    <!-- <b-card>
      <b-card-body>
        <DocumentUpload
          @deleteFile="deleteFile"
          @downloadFile="downloadFile"
          @uploadFiles="uploadFiles"
          @documentDetails="documentDetails"
        />
      </b-card-body>
    </b-card> -->

    <!-- <b-col md="12" class="d-flex justify-content-between">
      <b-button type="submit" variant="primary" :disabled="loading"
        ><b-spinner small v-if="loading" class="mx-2" />Submit</b-button
      >
    </b-col> -->
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BForm,
  BButton,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormCheckbox,
  BFormFile,
  BContainer,
  BCard,
  BCardBody,
  BCardText,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import { mapActions, mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { fnSortingDropdown } from "@/libs/customFn";
import { required } from "@validations";
import { ref, onUnmounted } from "@vue/composition-api";
import "@/libs/customValidation";
import {
  customLoader,
  customError,
  customSwal,
  customErrorMessage,
} from "@/libs/customFn";
import DocumentUpload from "../../../component/DocumentUpload.vue";
import "@/libs/customValidation";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";
export default {
  components: {
    BFormSelect,
    BFormFile,
    BFormGroup,
    BForm,
    BFormTextarea,
    BFormInput,
    FormWizard,
    BContainer,
    BButton,
    BFormCheckbox,
    BCard,
    BCardBody,
    TabContent,
    BRow,
    BCol,
    ToastificationContent,
    BCardText,
    BSpinner,
    quillEditor,
    DocumentUpload,

    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      itemFormHeight: null,
      taskFormHeight: null,
      processingData: null,
      id: this.$route.params.id,
      orderName: null,
      orderDescription: null,
      budget: null,
      editorOption: {
        modules: {
          toolbar: "#toolbar",
        },
      },
      defaultItem: [
        {
          tasks: null,
          resources: null,
          tools: null,
          price: 0.0,
        },
      ],
      items: [
        {
          tasks: null,
          resources: null,
          tools: null,
          price: 0.0,
        },
      ],
      nextTodoId: 1,
      documentDetails: [],
      optionsProduct: [],
      item: {
        qty: 1,
      },
      // add product modal
      prodName: "",
      prodQty: null,
      newProd: false,
      //currencyList: CurrencySymbols,
      selectedCurrency: "MUR",
      currencyOptions: [],
      staffOption: [],
      selectedStaffIds: [],
      staffpopulate: [],
      pushStaffIds: null,
      exchangeRate: 1,
      barcode: null,
      loadingButton: false,
      selectedProduct: null
    };
  },
  watch: {
    "ServiceTemplateObject.budget"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.budget = 0;
      }
    },
    "ServiceTemplateObject.estimatedDuration"(val) {
      if (val === "" || val === null) {
        this.ServiceTemplateObject.estimatedDuration = 0;
      }
    },
  },
  methods: {
    ...mapActions("serviceModule", [
      "addServiceTemplateAction",
      "getServiceTemplateFileListAction",
      "postServiceTemplateDocumentAction",
      "getStaffForTemplateListAction",
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
    ]),
    onlyDigits(event) {
      // Allow only digits (0-9)
      const charCode = event.charCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }
    },
    autoCorrectQty(value) {
      // Remove non-digit characters
      let cleaned = String(value).replace(/\D/g, '');

      // Convert to number and ensure it's at least 1
      let number = parseInt(cleaned, 10);
      if (isNaN(number) || number <= 0) {
        number = 1;
      }

      this.item.qty = number;
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div class='error-container'>";
        msg += "<p>Please check the following:</p>";

        const errorList = [];
        for (const [prop, errorMessages] of Object.entries(errors)) {
          if (prop !== "request") {
            errorMessages.forEach((error) => {
              errorList.push(this.getErrorDescription(prop, error));
            });
          }
        }

        // bullet list for errors
        msg += "<ul style='list-style-type: none; padding-left: 0;'>";
        errorList.forEach((error) => {
          msg += `<li style='margin-bottom: 8px;'>⚠️ ${error}</li>`;
        });
        msg += "</ul>";
        msg += "</div>";
      } else if (data.message) {
        msg = "<div class='error-container'>";
        msg += "<p>Please check the following:</p>";
        msg += `<p>${data.message}</p>`;
        msg += "</div>";
      }
      return msg;
    },
    errorAdd(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Something's not quite right",
        html: msg ?? data,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    showSuccess() {
      this.$swal({
        title: "Service Template Created!",
        text: "You have successfully Created a Service Template!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(() => {
        this.$router.push({ name: "templates-list" });
      });
    },
    showProcessingDialog(text = "Please wait while the data is being loaded") {
      this.processingData = this.$swal({
        title: "Processing...",
        text: text,
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
    },
    extractStaffIds() {
      const staffIds = this.selectedStaffIds.map((staff) => staff.id);
      return staffIds.join(",");
    },
    hideProcessingDialog() {
      if (this.processingData) {
        this.processingData.close();
        this.processingData = null;
      }
    },
    downloadFile() { },
    uploadFiles() { },
    deleteFile() { },
    formChanged() { },
    async formValidation() {
      const isValidMainForm = await this.$refs.AddServiceTemplate.validate();

      if (!isValidMainForm) return;
      const isValidSubForm =
        await this.$refs.AddServiceTemplateDetails.validate();
      const hasValue = this.items.length > 0 ? true : false;

      if (!hasValue) {
        customErrorMessage(
          "Please provide at least one template detail",
          "Template Detail"
        );
        return;
      }

      if (isValidMainForm && isValidSubForm) {
        let details = [];
        let products = [];

        if (this.items != null && this.items.length > 0) {
          this.items.forEach((detail, index) => {
            var obj = {};
            obj["OrderDetailTemplateId"] = detail.id;
            obj["Tasks"] = detail.tasks;
            obj["Resources"] = detail.resources;
            obj["Tools"] = detail.tools;
            obj["Price"] = detail.price;
            details.push(obj);
          });
        } else {
          details = null;
        }

        const mappedProducts = this.invoiceData.items
          .map((item) => {
            const ProductId = item.value || (item.id && item.id.value);
            const Quantity = item.qty;

            // Return an object only if ProductId exists
            return ProductId ? { ProductId, Quantity } : null;
          })
          .filter((item) => item !== null); // Filter out null values
        this.pushStaffIds = this.extractStaffIds();

        let payload = {
          OrderTemplateId: this.ServiceTemplateObject.id,
          OrderName: this.ServiceTemplateObject.orderName,
          OrderDescription: this.ServiceTemplateObject.orderDescription,
          Budget: this.ServiceTemplateObject.budget,
          StaffId: this.pushStaffIds,
          EstimatedDuration: this.ServiceTemplateObject.estimatedDuration,
          OrderTemplateDetails: details,
          OrderTemplateProducts: mappedProducts,
        };

        this.ServiceTemplateObject.orderTemplateDetails = this.items;
        this.ServiceTemplateObject.OrderTemplateProducts = mappedProducts;
        this.showProcessingDialog(
          "Please wait while the data is being process"
        );
        this.addServiceTemplateAction({ payload })
          .then(() => {
            this.hideProcessingDialog();
            this.showSuccess();
            //customSwal("Service Template created!");
          })
          .catch((ex) => {
            this.errorAdd(ex.response.data);
            //customError(ex.message);
          });
      } else {
        customErrorMessage(
          "Please fill out all required fields.",
          "Required Fields"
        );
      }
    },
    AddNew() {
      let dynamicValue = this.defaultItem.length > 0 ? this.defaultItem[0] : [];
      let clonedValue = Object.assign({}, dynamicValue);
      this.items.push(clonedValue);
      this.$nextTick(() => {
        this.adjustHeight("task");
      });
    },
    removeItem(index, type) {
      if (type === "item") {
        this.invoiceData.items.splice(index, 1);
        

      } else if (type === "task") {
        this.items.splice(index, 1);
      }
      this.trTrimHeight(this.$refs.row[0].offsetHeight);

      
      this.$nextTick(() => {
        // Adjust heights dynamically after removing an item
        if (type === "item" && this.invoiceData.items.length === 0) {
          this.itemFormHeight = "auto";
        } else if (type === "task" && this.items.length === 0) {
          this.taskFormHeight = "auto";
        }


        setTimeout(() => {
          this.adjustHeight(type);
        }, 0); // Allow DOM updates before recalculating height
      });
    },
    initTrHeight(type) {
      this.trSetHeight(null);
      this.$nextTick(() => {

if(type == "item" )
{
  if(this.$refs.itemForm.scrollHeight) this.trSetHeight(this.$refs.itemForm.scrollHeight);

}
else
{
  if(this.$refs.taskForm.scrollHeight) this.trSetHeight(this.$refs.taskForm.scrollHeight);

}

      });
    },
    async loadProductList() {
      await this.getProductListAction(true).then(() => {
        this.ProductList.map((v, i) => {
          if (v.type !== 4) {
            this.optionsProduct.push({
              qty: 1,
              value: v.id,
              itemTitle: `${v.name}`,
            });
          }
        });
      });
      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
    },
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },

    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.adjustHeight("item");
      });
    },
    adjustHeight(type) {
      this.$nextTick(() => {
        if (type === "item" && this.$refs.itemForm) {
          this.itemFormHeight =
            this.invoiceData.items.length > 0
              ? `${this.$refs.itemForm.scrollHeight}px`
              : "0px"; // Set height to 0 if no items remain
        } else if (type === "task" && this.$refs.taskForm) {
          this.taskFormHeight =
            this.items.length > 0
              ? `${this.$refs.taskForm.scrollHeight}px`
              : "0px"; // Set height to 0 if no tasks remain
        }
      });
    },
    //  addItemWithBarcode() {
    //    if (!this.barcode) {
    //      return;
    //    }

    //    // Filter products by barcode
    //    let products = this.ProductList.filter((x) => x.barcode === this.barcode);

    //    // If more than one product is found, show the modal with radio buttons
    //    if (products && products.length > 1) {
    //      this.selectedProduct = products;

    //      // Map products to radio button options
    //      this.productOptions = products.map((product) => ({
    //        text: product.name,
    //        value: product.id,
    //      }));

    //      this.$bvModal.show("modal-barcode");
    //    } else if (products.length === 1) {
    //      // If only one product is found, add it directly to the invoice
    //      let productDetail = products[0];

    //      let index = this.invoiceData.items.length - 1;
    //      if (index >= 0 && this.invoiceData.items[index].id == undefined) {
    //        this.invoiceData.items.splice(index, 1);
    //      }

    //      this.invoiceData.items.push(
    //        JSON.parse(
    //          JSON.stringify({
    //            qty: 1,
    //            value: productDetail.id,
    //            id: {
    //              value: productDetail.id,
    //              itemTitle: `${productDetail.name}`,
    //            },
    //            itemTitle: `${productDetail.name}`,
    //            cost: productDetail.salePrice,
    //            tax: productDetail.saleTaxPercentage,
    //            purchase: productDetail.purchasePrice,
    //            profit: productDetail.markUpPercentage,
    //            description: productDetail.description,
    //            discount: 0,
    //            discountType: 0,
    //          })
    //        )
    //      );
    //    }

    //    // Clear the barcode field
    //    this.barcode = null;
    //  },

    addProductFromModal(selectedProductId) {
      let selectedProduct = this.ProductList.find(
        (product) => product.id === selectedProductId
      );

      if (selectedProduct) {
        this.invoiceData.items.push({
          qty: 1,
          value: selectedProduct.id,
          id: {
            value: selectedProduct.id,
            itemTitle: `${selectedProduct.name}`,
          },
          itemTitle: `${selectedProduct.name}`,
        });

        this.item.id = selectedProduct.id;

        // Hide the modal
        this.$bvModal.hide("modal-barcode");

        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0].offsetHeight);
          setTimeout(() => {
            this.$refs.itemForm.style.overflow = null;
          }, 350);
        });
      }
    },
    async validateCurrencyRate() {
      let isValid = await this.$refs.quote.validate({ field: "exchangeRate" });
      return isValid;
    },
    ensureNotNull(index) {
      if (
        this.items[index].discount == null ||
        this.items[index].discount === ""
      ) {
        this.items[index].discount = 0;
      }
    },
    ensureMainDiscountNotNull() {
      if (this.MainDiscount == null || this.MainDiscount === "") {
        this.MainDiscount = 0;
      }
      this.formatDiscount();
    },
    formatDiscount() {
      if (this.MainDiscount) {
        this.MainDiscount = parseFloat(this.MainDiscount).toFixed(2);
      }
    },
    itemCost(cost, qty, discountType, discount) {
      cost = Number(cost);
      qty = Number(qty);
      discount = Number(discount);

      if (isNaN(cost) || isNaN(qty) || isNaN(discount)) {
        return "0.00";
      }

      let result = cost * qty;

      if (discountType == 0) {
        let discountAmount = result * (discount / 100);

        // Check if discountAmount is greater than the cost of all items
        if (discountAmount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discountAmount = result;
        }
        result = result - discountAmount;
      } else if (discountType == 1) {
        // Check if flat discount is greater than the cost of all items
        if (discount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discount = result;
        }
        result = result - discount;
      }
      return result.toFixed(2);
    },
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  beforeMount() {
    this.getProductListAction(true);
    this.loadProductList();
  },
  async mounted() {
    this.adjustHeight("item");
    this.adjustHeight("task");
    this.items = [];
    this.initTrHeight();

    if (HasPermission(PermissionList.Inventory_Create) && (this.ProductList == undefined || this.ProductList.length == 0)){
      console.log("getproductlist", this.ProductList);
      //await this.getProductListAction(true);
      //await this.loadProductList();
    }

    await this.getStaffForTemplateListAction().then(() => {
      this.staffoption = this.staffList;
      this.staffpopulate = this.staffoption.map((option) => ({
        id: option.id,
        name: option.firstName + option.lastName,
      }));
    });
  },

  setup() {
    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 1,
      tax: 0,
      profit: 0,
      description: "",
      discountType: 0,
      discount: 0,
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val) => {
      const { qty, value } = val;
      invoiceData.value.items[index].qty = val.qty;
      invoiceData.value.items[index].value = val.value;
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
      HasPermission,
      PermissionList
    };
  },
  computed: {
    selectedCurrencySign() {
      return this.currencyList[this.selectedCurrency] || "Rs";
    },

    subTotalAmount() {
      let total = 0;
      total = this.totalCost - this.salesTax;
      return total.toFixed(2);
    },
    ...mapGetters("serviceModule", {
      ServiceTemplateObject: "serviceOne",
      staffList: "stafflistrequests",
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
</style>

<style lang="scss">
.form-item-section {
  //  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  margin: 0;
  padding: 0;
  overflow: hidden;
  transition: height 0.35s ease;

  &:empty {
    display: none;
  }
}

.b-row {
  margin: 0 !important;
  padding: 0.5rem 0 !important;
  border: none;
  transition: 0.2s ease;
}

.repeater-form:empty {
  display: none;
}

.v-select {

  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    // background-color: $theme-dark-body-bg;

    .row .border {
      //    background-color: $theme-dark-card-bg;
    }
  }
}
</style>

<style scoped>
label {
  font-size: 1.714rem !important;
  font-weight: 500;
  margin-bottom: 0;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
